module.exports = __webpack_public_path__ + "media/images/prize__saint-pedals-af7205b56073fc5d85dfc71dc88fac15.jpg";